import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { GoArrowLeft } from "react-icons/go";
import { FaBook, FaHeart } from "react-icons/fa";
import { FaComment } from "react-icons/fa";
import { FaShare } from "react-icons/fa";
import { FaBookmark } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { FaNewspaper } from "react-icons/fa6";
import { useContext } from "react";
import { SafeAreaContext } from "../../../App";
import { IoIosSend } from "react-icons/io";
import NewsService from "../../../services/News";
import { useParams } from "react-router-dom";
import Url from "../../../url/Url";
import anonymous from "../../../assets/images/anonymous.jpg.webp";
import { useNavigate } from "react-router-dom";

export default function NewsDetail() {
  const [actionOpen, setActionOpen] = useState(false);
  const commentInputRef = useRef(null);
  const { id } = useParams();
  const [newsDetail, setNewsDetail] = useState(null);
  const [likesCount, setLikesCount] = useState("");
  const navigate = useNavigate();

  //safArea for Pwa////////
  const { setSafeAreaColor } = useContext(SafeAreaContext);

  useEffect(() => {
    setSafeAreaColor({ background: "#FFFFFF" });
  }, []);
  ////////////////////////

  async function getDetail() {
    try {
      const res = await NewsService.getDetail(id);
      setNewsDetail(res.data.data);
      setLikesCount(res.data.data.likesCount || 0);
      setIsLike(res.data.data.isLiked || false);
    } catch (err) {
      console.log("error fetching news detail:", err);
    }
  }
  useEffect(() => {
    getDetail();
  }, [id]);

  useEffect(() => {
    function onDocClick(e) {
      const menu = document.getElementById("header-action-menu");
      const btn = document.getElementById("header-action-btn");
      if (!menu || !btn) return;
      if (!menu.contains(e.target) && !btn.contains(e.target)) {
        setActionOpen(false);
      }
    }
    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, []);

  const [comments, setComments] = useState([]);
  const [showAllComments, setShowAllComments] = useState(false);
  const [isSubmittingComment, setIsSubmittingComment] = useState(false);

  useEffect(() => {
    const fetchComments = async () => {
      try {
        const res = await NewsService.getCommentsById(id);
        setComments(res?.data?.data || []);
      } catch (err) {
        console.log("error fetching comments:", err);
      }
    };

    if (id) {
      fetchComments();
    }
  }, [id]);

  const handleSendComment = async (commentText) => {
    setIsSubmittingComment(true);
    try {
      const commentData = {
        targetId: id,
        content: commentText,
      };
      const res = await NewsService.sendComment(commentData);

      if (commentInputRef.current) {
        commentInputRef.current.value = "";
      }

      const updatedComments = await NewsService.getCommentsById(id);
      setComments(updatedComments?.data?.data || []);
    } catch (err) {
      console.log("error sending comment:", err);
    } finally {
      setIsSubmittingComment(false);
    }
  };

  const [isLike, setIsLike] = useState(newsDetail?.isLiked || false);



  async function handleLikeAndDisLikeNews() {
    if (!newsDetail?._id) return;

    const previousLike = isLike;
    const previousCount = likesCount;

    try {
      const param = { newsId: newsDetail._id };

      if (!isLike) {
        setIsLike(true);
        setLikesCount((prev) => prev + 1);
        await NewsService.LikeNews(param);
      } else {
        setIsLike(false);
        setLikesCount((prev) => prev - 1);
        await NewsService.DisLikeNews(param);
      }
    } catch (err) {
      // If an error occurs, revert the states
      setIsLike(previousLike);
      setLikesCount(previousCount);
      console.error("Error liking/disliking news:", err);
    }
  }

  const sectionVariants = {
    hidden: { opacity: 0, y: 12 },
    visible: (i = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.45, delay: i * 0.06 },
    }),
  };

  const openAction = (e) => {
    e.stopPropagation();
    setActionOpen((p) => !p);
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          text: "https://api.7-trade.ir/newsDetail/" + newsDetail._id,
        });
      } catch (err) {}
    } else {
    }
  };

  const timeAgo = (date) => {
    const diff = (Date.now() - new Date(date)) / 1000; // seconds

    if (diff < 60) return `${Math.floor(diff)} second ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)} minute ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} hour ago`;
    return `${Math.floor(diff / 86400)} day ago`;
  };

  return (
    <div className="min-h-screen bg-gray-100 pb-[100px] font-sans text-[14px]">
      {/* ====== Styles (keyframes + helper classes) ====== */}
      <style>{`
        @keyframes openMenuFromTop {
          0% { top: 30px; opacity: 0.1; }
          100% { top: 50px; opacity: 1; }
        }
        .animate-open-menu {
          animation: openMenuFromTop 280ms cubic-bezier(.22,.9,.34,1) forwards;
        }

        @keyframes news-pulse {
          0%,100% { transform: scale(1); }
          50% { transform: scale(1.08); }
        }
        .news-pulse {
          animation: news-pulse 2s infinite ease-in-out;
        }

        /* small visual polish: smooth dropdown opacity transform */
        .action-menu-enter { opacity: 0; transform: translateY(-6px) scale(.98); }
        .action-menu-enter-active { opacity: 1; transform: translateY(0) scale(1); transition: all .25s cubic-bezier(.22,.9,.34,1); }

        /* keep scrollbar hidden like original */
        ::-webkit-scrollbar { display: none; }
      `}</style>

      {/* ====== Header ====== */}
      <header
        id="header"
        className="bg-white shadow-md py-5 pr-5 sticky top-0 z-50 border-b border-gray-200"
      >
        <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
                <button
                    onClick={() => navigate("/news")}
                    className="text-primary hover:text-blue-700 transition-colors ml-3 mb-0.5"
                    aria-label="back"
                >
                    <GoArrowLeft
                        strokeWidth={1}
                        size={25}
                        className="fas fa-arrow-left text-xl"
                    ></GoArrowLeft>
                </button>
                <h2 className="font-bold text-dark text-lg text-left flex-1 mr-2">
                    News Details
                </h2>
            </div>




          <div className="relative flex items-center space-x-3">
            {/* <button
              id="header-action-btn"
              onClick={openAction}
              className="text-secondary hover:text-primary transition-colors"
              aria-label="actions"
            >
                <FaShare size={20} className="fas fa-ellipsis-v text-lg"></FaShare>
      
            </button> */}

            {/* Action menu (animated from top using openMenuFromTop keyframes) */}
            {/* {actionOpen && (
              <div
                id="header-action-menu"
                className="absolute left-0 top-[50px] z-40 bg-white rounded-xl border border-gray-200 shadow-lg min-w-[180px] p-2 animate-open-menu"
                style={{ right: "0", left: "auto" }}
              >
                <button className="w-full text-right px-3 py-2 rounded-lg hover:bg-gray-50 text-sm">Share</button>
                <button className="w-full text-right px-3 py-2 rounded-lg hover:bg-gray-50 text-sm">Save</button>
                <div className="border-t border-gray-100 my-1" />
                <button className="w-full text-right px-3 py-2 rounded-lg hover:bg-gray-50 text-sm">Report</button>
              </div>
            )} */}

            {/* <div className="flex items-center space-x-3">
              <button
                onClick={handleShare}
                className="text-secondary hover:text-primary transition-colors"
                aria-label="share"
              >
                <FaShare size={20} className="fas fa-share text-lg"></FaShare>
              </button>
              <button
                className="text-secondary hover:text-primary transition-colors"
                aria-label="bookmark"
              >
                <FaBookmark
                  size={20}
                  className="fas fa-share text-lg"
                ></FaBookmark>
              </button>
            </div> */}
          </div>
        </div>
      </header>

      {/* ====== Main Content ====== */}
      <main id="news-detail-content" className="pt-5 pb-5 px-5 space-y-5">
        {/* News Header */}
        <motion.section
          id="news-header"
          className="bg-white rounded-xl shadow-lg p-5"
          initial="hidden"
          animate="visible"
          custom={0}
          variants={sectionVariants}
        >
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-[#0000FF] rounded-full flex items-center justify-center ml-3">
                <FaNewspaper
                  size={18}
                  className="fas fa-newspaper text-white text-lg news-pulse"
                ></FaNewspaper>
              </div>

              <div>
                <h3 className="font-bold text-sm text-secondary">
                  {newsDetail?.newsTypes || "Economic News"}
                </h3>
                <p className="text-sm text-secondary">
                  {newsDetail?.createdAt
                    ? new Date(newsDetail.createdAt).toLocaleString("En")
                    : "30 minutes ago"}
                </p>
              </div>
            </div>

            <div className="text-left">
              {newsDetail?.hashtags && newsDetail.hashtags.length > 0 && (
                <span className="bg-red-500 text-white text-sm font-bold px-3 py-1 rounded-full">
                  {newsDetail.hashtags[0]}
                </span>
              )}
            </div>
          </div>

          <h1 dir="ltr" className="text-xl font-bold text-dark mb-4 leading-relaxed text-left">
            {newsDetail?.title ||
              "Central Bank Raises Interest Rate by 0.25%; Impact on Financial Markets"}
          </h1>

          <div className="mb-4">
            <motion.img
              src={
                newsDetail?.imageId?.path
                  ? `https://api.7-trade.ir/${newsDetail.imageId.path}`
                  : "https://storage.googleapis.com/uxpilot-auth.appspot.com/0a0297bce8-d54928a522521059c72f.png"
              }
              alt={newsDetail?.title || "central bank"}
              className="w-full h-48 rounded-lg object-cover"
              initial={{ opacity: 0, scale: 0.995 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.45 }}
            />
          </div>

          <div className="flex items-center justify-between text-sm text-secondary mb-4 pt-3 border-t border-gray-200">
            <div className="flex items-center space-x-4">
              <button
                onClick={handleLikeAndDisLikeNews}
                className={`flex flex-row gap-2 transition-colors ${
                  isLike ? "text-red-500" : "text-secondary"
                }`}
              >
                <FaHeart
                  size={15}
                  className={`fas fa-comment ml-1 ${
                    isLike ? "text-red-500" : ""
                  }`}
                />
                {likesCount || 0}
              </button>
              <span
                onClick={() =>
                  document
                    .getElementById("comments")
                    .scrollIntoView({ behavior: "smooth" })
                }
                className="flex flex-row gap-2"
              >
                <FaComment
                  size={15}
                  className="fas fa-comment ml-1"
                ></FaComment>{" "}
                {comments.length}
              </span>

              <span className="flex flex-row gap-2">
                <FaEye size={15} className="fas fa-comment ml-1"></FaEye>{" "}
                {newsDetail?.views || 0}
              </span>
            </div>
            <span>
              Author: {newsDetail?.adminId?.userName}
            </span>
          </div>
        </motion.section>

        {/* News Content */}
        <motion.section
          id="news-content"
          className="bg-white rounded-xl shadow-lg p-5"
          initial="hidden"
          animate="visible"
          custom={1}
          variants={sectionVariants}
        >
          <div
            dir="ltr"
            className="prose prose-lg max-w-none text-dark leading-relaxed text-left"
          >
            <p className="mb-4">
              {newsDetail?.body ||
                "The Central Bank of the Islamic Republic of Iran today decided to raise the base interest rate by 0.25%. This decision, made after reviewing economic indicators and inflation rates, brought the interest rate from 18% to 18.25%."}
            </p>

            {newsDetail?.importantPoints &&
              newsDetail.importantPoints.length > 0 && (
                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200 mb-4">
                  <h4 className="font-bold text-dark mb-2 text-right">
                    Key Points:
                  </h4>
                  <ul className="list-disc list-inside text-dark space-y-1 text-right">
                    {newsDetail.importantPoints.map((point, index) => (
                      <li key={index}>{point}</li>
                    ))}
                  </ul>
                </div>
              )}
          </div>
        </motion.section>

        {/* Related News */}
        {/* <motion.section
          id="related-news"
          className="bg-white rounded-xl shadow-lg p-5"
          initial="hidden"
          animate="visible"
          custom={2}
          variants={sectionVariants}
          dir="rtl"
        >
          <h4 className="font-bold text-dark mb-4 text-right">Related News</h4>

          <div  className="space-y-4">
            <div className="flex items-start space-x-reverse space-x-3 p-4 bg-gray-50 rounded-lg">
              <div className="w-16 h-12 bg-gray-300 rounded-lg flex-shrink-0 overflow-hidden">
                <img className="w-full h-full rounded-lg object-cover" src="https://storage.googleapis.com/uxpilot-auth.appspot.com/912e07d141-10a5e98482534b2a3369.png" alt="related1" />
              </div>
              <div className="flex-1 text-left">
                <h5 className="font-semibold text-sm text-dark  text-right  mb-1">Stock Index Ends Day Down 2%</h5>
                <p className="text-xs text-secondary">1 hour ago</p>
              </div>
            </div>

            <div className="flex items-start space-x-reverse space-x-3 p-4 bg-gray-50 rounded-lg">
              <div className="w-16 h-12 bg-gray-300 rounded-lg flex-shrink-0 overflow-hidden">
                <img className="w-full h-full rounded-lg object-cover" src="https://storage.googleapis.com/uxpilot-auth.appspot.com/bc9b8748ea-3e98ffaa83d0cd2508cb.png" alt="related2" />
              </div>
              <div className="flex-1 text-left">
                <h5 className="font-semibold text-sm  text-right  text-dark mb-1">Domestic Gold Price Rises 3%</h5>
                <p className="text-xs text-secondary">2 hours ago</p>
              </div>
            </div>
          </div>
        </motion.section> */}

        {/* Comments */}
        <motion.section
          id="comments"
          className="bg-white rounded-xl shadow-lg p-5"
          initial="hidden"
          animate="visible"
          custom={3}
          variants={sectionVariants}
          dir="rtl"
        >
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3 space-x-3">
              {/* <button
                onClick={handleLikeAndDisLikeNews}
                className={`flex flex-row gap-1 transition-colors ${
                  isLike ? "text-red-500" : "text-secondary hover:text-red-500"
                }`}
              >
                <p>{likesCount || 0}</p>
                <FaHeart
                  size={15}
                  className={`fas fa-comment ml-1 ${
                    isLike ? "text-red-500" : ""
                  }`}
                />
              </button> */}
              {comments.length > 5 && (
                <button
                  onClick={() => setShowAllComments(!showAllComments)}
                  className="text-primary text-sm font-semibold"
                >
                  {showAllComments
                    ? `Close (${comments.length})`
                    : `View All (${comments.length})`}
                </button>
              )}
            </div>
            <h4 className="font-bold text-dark text-right">
              Comments ({comments.length})
            </h4>
          </div>

          <div className="space-y-4">
            {comments.length > 0 ? (
              (showAllComments ? comments : comments.slice(0, 5)).map(
                (comment) => (
                  <div
                    key={comment._id}
                    dir="ltr"
                    className="flex items-start space-x-3 p-4 bg-gray-50 rounded-lg"
                  >
                    <img
                      alt={comment.author?.fullName || "Unknown user"}
                      src={Url + comment.author?.imageId?.path || anonymous}
                      className="w-8 h-8 rounded-full"
                    />
                    <div className="flex-1 text-left">
                      <div className="flex items-center justify-start space-x-2 mb-1">
                        <p className="font-semibold text-sm text-dark">
                          {comment.author?.fullName || "Unknown user"}
                        </p>
                        <span className="text-xs text-secondary">
                          {timeAgo(comment.createdAt)}
                        </span>
                      </div>
                      <p className="text-sm text-dark break-all">{comment.content}</p>
                    </div>
                  </div>
                  // <div key={comment._id} className="flex items-start space-x-reverse space-x-3 p-4 bg-gray-50 rounded-lg">
                  //   <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center text-white text-sm font-bold">
                  //     {comment.author?.userName ? comment.author.userName.charAt(0).toUpperCase() : 'ک'}
                  //   </div>
                  //   <div className="flex-1 text-left">
                  //     <div className="flex items-center justify-start gap-3 mb-1">
                  //       <p className="font-semibold text-sm text-dark">
                  //         {comment.author?.userName || 'کاربر ناشناس'}
                  //       </p>
                  //       <span className="text-xs text-secondary">
                  //         {new Date(comment.createdAt).toLocaleDateString('fa-IR', {
                  //           year: 'numeric',
                  //           month: 'short',
                  //           day: 'numeric',
                  //           hour: '2-digit',
                  //           minute: '2-digit'
                  //         })}
                  //       </span>
                  //     </div>
                  //     <p className="text-sm text-right text-dark">{comment.content}</p>
                  //   </div>
                  // </div>
                )
              )
            ) : (
              <div className="text-center py-8 text-gray-500">
                <p>No comments yet</p>
                <p className="text-sm mt-1">Be the first to leave a comment</p>
              </div>
            )}
          </div>

          {/* Add Comment */}
          <div
            className="flex items-center space-x-reverse space-x-3 mt-5 pt-4 border-t border-gray-200"
          >
            <button
              onClick={() => {
                const commentText = commentInputRef.current?.value ?? "";
                if (commentText.trim() && !isSubmittingComment) {
                  handleSendComment(commentText.trim());
                }
              }}
              disabled={isSubmittingComment}
              className={`px-2 py-2 rounded-lg transition-all ${
                isSubmittingComment
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#0000FF] hover:bg-blue-600"
              } text-white`}
            >
              {isSubmittingComment ? (
                <div className="animate-spin w-5 h-5 border-2 border-white border-t-transparent rounded-full"></div>
              ) : (
                <IoIosSend size={20} className="fas fa-paper-plane"></IoIosSend>
              )}
            </button>
           <input
                  ref={commentInputRef}
                  type="text"
                  placeholder="Write your comment"
                  disabled={isSubmittingComment}
                  dir="ltr"
                  className={`w-full pr-4 pl-12 py-3 bg-gray-50 border border-gray-200 ps-16 rounded-2xl placeholder:text-start focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-left ${
                    isSubmittingComment ? "bg-gray-100 cursor-not-allowed" : ""
                  }`}
              onKeyPress={(e) => {
                if (e.key === "Enter" && !isSubmittingComment) {
                  const commentText = e.target.value.trim();
                  if (commentText) {
                    handleSendComment(commentText);
                  }
                }
              }}
            />
          </div>
        </motion.section>
      </main>
    </div>
  );
}